module.exports = __webpack_public_path__ + "static/assets/67a40d0bc1e92bcaeb8bbef1886aa1de.svg";